import React from 'react'
import styled, { css } from 'styled-components'
import { SH4, STypographyDesc } from '@components/Typography'
import Box from '@components/Box'
import Container from '@components/Container'
import { above } from '@styles/mixins/breakpoints'
import { copyright, marks } from './data'
import Menu from './Menu'

const SFooter = styled.footer`
  background-color: ${({ theme }) => theme.colors.lightGray};
  margin-top: 36px;
`

const SMarks = styled(Box)`
  a:not(:last-child) {
    margin-right: 20px;
  }
`

const SLink = styled.a`
  transition: 0.2s;
  &:hover {
    color: black;
  }
`

const SContainer = styled(Container)`
  padding-bottom: 40px;
  padding-top: 40px;

  ${above('xl')(css`
    padding-bottom: 60px;
    padding-top: 64px;
  `)}
`

const SCopyright = styled.div`
  margin-top: 24px;
  display: block;
  align-items: center;

  ${above('xl')(css`
    margin-top: 60px;
    display: flex;
  `)}
`

const Footer: React.FC = () => (
  <SFooter>
    <SContainer>
      <Menu />
      <Box mt="24px" display={{ _: 'block', xl: 'none' }}>
        <SH4 as="a" href="tel:88005555550" color="graphite">
          8 (800) 555-55-50 или 900
        </SH4>
        <STypographyDesc mt="4px">Для бесплатных звонков с любых телефонов на территории России</STypographyDesc>
      </Box>
      <SCopyright>
        <Box width={{ _: '100%', xl: '65%' }} marginRight={{ _: '0', xl: '5%' }}>
          <STypographyDesc>{copyright}</STypographyDesc>
        </Box>
        <SMarks width={{ _: '100%', xl: '30%' }} mt={{ _: '24px', xl: '0' }}>
          {marks.map(({ href, icon, targetBlank }, i) => (
            <a key={i} href={href} {...(targetBlank ? { ...{ target: '_blank' } } : {})}>
              {icon}
            </a>
          ))}
        </SMarks>
      </SCopyright>
      <STypographyDesc mt="24px" color="gray">
        <SLink target="_blank" href="https://npfsberbanka.ru/upload/ACB.pdf">
          Свидетельство №2
        </SLink>{' '}
        о внесении в реестр негосударственных пенсионных фондов - участников системы гарантирования прав застрахованных
        лиц в системе обязательного пенсионного страхования. Воспроизведение материалов сайта возможно только с
        указанием ссылки на источник.
        <br />
        <br />
        Сайт{' '}
        <SLink href="https://npfsberbanka.ru/" target="_blank">
          npfsberbanka.ru
        </SLink>{' '}
        зарегистрирован как СМИ,{' '}
        <SLink target="_blank" href="https://npfsberbanka.ru/upload/Svid.pdf">
          ЭЛ №ФС77-63615
        </SLink>{' '}
        от 2 ноября 2015 года. info@npfsb.ru
      </STypographyDesc>
    </SContainer>
  </SFooter>
)

export default Footer
